import { FC, useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import {
  ResourceDetailsGeneralContentK8SViewSelect,
  UtilizationOrReservation,
} from "@/components/pages/common/resource-details/components/content/general-content/components/kubernetes/usage/ResourceDetailsGeneralContentK8SViewSelect";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsTargetResourceSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceSelector";
import { ResourceDetailsGeneralContentK8SUsageReservation } from "@/components/pages/common/resource-details/components/content/general-content/components/kubernetes/usage/ResourceDetailsGeneralContentK8SUsageReservation";
import { ResourceDetailsGeneralContentK8SUsageUtilization } from "@/components/pages/common/resource-details/components/content/general-content/components/kubernetes/usage/ResourceDetailsGeneralContentK8SUsageUtilization";

interface ResourceDetailsK8SMetricsTabContentProps {
  padding?: number;
}

export const ResourceDetailsK8SMetricsTabContent: FC<
  ResourceDetailsK8SMetricsTabContentProps
> = ({ padding = 2 }) => {
  const [view, setView] = useState<UtilizationOrReservation>("reservation");

  const resource = useAppSelector(resourceDetailsTargetResourceSelector);

  const resourceType = resource?.resourceType;

  useEffect(() => {
    setView(resourceType === "kubernetes_node" ? "reservation" : "utilization");
  }, [resourceType]);

  return (
    <Stack spacing={1} p={padding}>
      {resourceType === "kubernetes_node" && (
        <ResourceDetailsGeneralContentK8SViewSelect
          view={view}
          setView={setView}
        />
      )}

      {view === "reservation" && (
        <ResourceDetailsGeneralContentK8SUsageReservation />
      )}

      {view === "utilization" && (
        <ResourceDetailsGeneralContentK8SUsageUtilization />
      )}
    </Stack>
  );
};
